<template>
	<div class="text-left">
		<loading :active.sync="isLoading"></loading>
		<div class="element-wrapper">
			<h6 class="element-header capitalize">
				{{ t.navigation.credits }}

			</h6>
				<div class="row">
					<div class="col-12">
						<div class="form-group">
							<label for="">{{ t.amount }}</label>
							<div class="input-group">
								<input class="form-control" v-model="amount" placeholder="Amount..." type="text" value="0.00">
								<div class="input-group-append">
									<div class="input-group-text">
										{{ tr.currency.iso_code }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<button class="btn btn-success btn-block btn-lg"  v-on:click="setTransaction()"><span>{{ t.get_payment }}</span></button>
					</div>

					<div class="col-12 pt-3">
						<div class="col alert alert-success" v-if="success">{{ success }}</div>
						<div class="col alert alert-danger" v-if="error">{{ error }}</div>
					</div>
				</div>

			<div class="row pt-5">




			</div>

			<b-tabs>
				<b-tab :title="t.detail" active>

					<div class="col-12 pt-5">
						<div class="row">


							<div class="col-4">
								<div class="listy b-b">
									<span class="label">{{ t.debtor }}</span>
									{{ tr.user.name }}
								</div>
							</div>

							<div class="col-4">
								<div class="listy b-b">
									<span class="label">{{ t.user.username }}</span>
									{{ tr.user.username }}
								</div>
							</div>

							<div class="col-4">
								<div class="listy b-b">
									<span class="label">{{ t.user.balance }}</span>
									{{ tr.user.balance | toMoney(tr.user.currency) }}
								</div>
							</div>

							<div class="col-4">
								<div class="listy b-b text-success">
									<span class="label">{{ t.paid }}</span>
									{{ tr.paid | toMoney(tr.currency) }}
								</div>
							</div>

							<div class="col-4">
								<div class="listy b-b text-danger">
									<span class="label">{{ t.remaining_debt }}</span>
									{{ tr.amount - tr.paid | toMoney(tr.currency) }}
								</div>
							</div>

							<div class="col-4">
								<div class="listy b-b">
									<span class="label">{{ t.debt }}</span>
									{{ tr.amount | toMoney(tr.currency) }}
								</div>
							</div>

							<div class="col-12">
								<div class="listy b-b">
									<span class="label">{{ t.created_at }}</span>
									{{ dateTimeFormat(tr.createdAt) }} • {{ tr.createdAt | timeAgo }}
								</div>
							</div>

							<div class="col-12">
								<div class="listy b-b text-danger">
									<span class="label">{{ t.expiry_date }}</span>
									{{ dateTimeFormat(tr.expiryAt) }} • {{ tr.expiryAt | timeAgo }}
								</div>
							</div>

							<div class="col-12">
								<div class="listy b-b text-primary">
									<span class="label">{{ t.last_transaction }}</span>
									{{ dateTimeFormat(tr.lastPaidAt) }} • {{ tr.lastPaidAt | timeAgo }}
								</div>
							</div>
						</div>
					</div>

				</b-tab>
				<b-tab :title="t.payment_history" >

					<div class="col-12 p-0 pt-5">
						<template v-for="transaction in transactions" v-if="transactions">
							<div class="row">
								<div class="col-6 p-0">
									<div class="listy b-b">
										<span class="label">{{ t.created_at }}</span>
										{{ dateTimeFormat(transaction.lastPaidAt) }} • {{ transaction.lastPaidAt | timeAgo }}
									</div>
								</div>
								<div class="col-6 p-0">
									<div class="listy b-b">
										<span class="label">{{ t.paid }}</span>
										{{ transaction.amount | toMoney(tr.currency) }}
									</div>
								</div>
							</div>
						</template>
					</div>
				</b-tab>
			</b-tabs>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'creditPayment',
        data () {
            return {
                t: this.$root.t,
                amount: '0.00',
                tr: null,
                error: null,
                success: null,
                isLoading: false,
                transactions: null
            }
        },
	    watch: {
            'transaction' (o,n) {
                this.tr = this.transaction;
		    }
	    },
	    props: {
            transaction: {
                type: Object,
	            required: true
            }
	    },
	    mounted () {
            this.tr = this.transaction;
            this.fetchTransactions();
	    },
	    methods: {
            setTransaction () {

                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.post(api+'api/v1/credit/collecting', { amount: this.amount, pid: this.transaction.id }).then(response => {

                    this.error = null;
                    this.success = response.body.msg;
                    this.tr = response.body.result.transaction;
                    this.status = response.status;
                    this.isLoading = false;

                    setTimeout(() => {
                        this.success = null;
                }, 5000);
                }, response => {
                        setTimeout(() => {
                            this.error = null;
                    }, 5000);
                        this.isLoading = false;
                        this.success = null;
                        this.status = response.status;
                        this.error = response.body.error;
                    })
                }

            },
            fetchTransactions () {

                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/user/transactions?noCache=1', {params: {dataId: [this.transaction.id]} }).then(response => {
                        // get body data

                    this.transactions = response.body.result.transactions;
                    this.isLoading = false;

                }, response => {
                        this.isLoading = false;
                    })


                }

            },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/creditPayment.vue